import React, { useState, useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import './ToggleSwitch.css';
import { ManagerlApi } from '../../API/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { FaTrash } from 'react-icons/fa';

const RoadLaneTab = () => {
  const { setRunRoadLane } = useFileContext();
  const [folderPath, setFolderPath] = useState('');
  const [dbName, setDbName] = useState('');
  const [roadClass, setRoadClass] = useState(1);
  const [pointsInterval, setPointsInterval] = useState(3.048);
  const [collectionName, setCollectionName] = useState('');
  const [showCheckMark, setShowCheckMark] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState('');
  const [requests, setRequests] = useState([]);


  const extractFolderId = (url) => {
    const parts = url.split('/');
    return parts[parts.length - 1];
  };

  // Helper function to format date and time
  const formatDateTime = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleRunRoadLane = async () => {
    const folderId = extractFolderId(folderPath);
    if (!folderId) {
      console.error('Invalid folder URL');
      return;
    }

    const apiUrl = `${ManagerlApi}/road-lane/${folderId}`;

    // Set current folderId and trigger the check mark display
    setCurrentFolderId(folderId);
    setShowCheckMark(false);

    // Add the request to the list with start time and default status
    const requestId = uuidv4();

    const RoadLane_params = {
        road_class: Number(roadClass),
        interval:parseFloat(pointsInterval),
        db: dbName,
        collection: collectionName,
      };

    const startTime = formatDateTime(new Date()); // Get current time
    setRequests((prevRequests) => [
      ...prevRequests,
      {
        id: requestId,
        folderId,
        status: 'In Progress',
        loading: true,
        startTime, // Store start time
        RoadLane_params, // Store the request parameters
        showParams: false, // Track if parameters are shown
      },
    ]);

    setFolderPath(''); // Clear the folder path input immediately

    try {
      const response = await axios.post(apiUrl, RoadLane_params, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Update the request status in the list with response message
      const statusMessage = response.data.message || 'Task Completed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${statusMessage} ✅`, loading: false }
            : request
        )
      );
    } catch (error) {
      console.error('There was an error running RoadLane!', error);

      // Update the request status in the list with error message
      const errorMessage = error.response?.data?.message || 'Task Failed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${errorMessage} ❌`, loading: false }
            : request
        )
      );
    }
  };

  const handleDeleteRequest = (id) => {
    setRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== id)
    );
  };

  const handleClearAll = () => {
    setRequests([]);
  };

  const toggleParamsVisibility = (id) => {
    setRequests((prevRequests) =>
      prevRequests.map((request) =>
        request.id === id ? { ...request, showParams: !request.showParams } : request
      )
    );
  };

  useEffect(() => {
    setRunRoadLane(() => handleRunRoadLane);
  }, [folderPath, setRunRoadLane]);

  return (
    <div>
      <div>
        <label>Folder Path (contains classified las files)</label>
        <input
          type='text'
          value={folderPath}
          onChange={(e) => setFolderPath(e.target.value)}
        />
      </div>
      <div>
        <label>Road Class</label>
        <input
          type="text"
          value={roadClass}
          onChange={(e) => setRoadClass(e.target.value)}
        />
      </div>
      <div>
        <label>Distance Between Points (Meter)</label>
        <input
          type="text"
          value={pointsInterval}
          onChange={(e) => setPointsInterval(e.target.value)}
        />
      </div>
      <div>
        <label>Database Name</label>
        <input
          type="text"
          value={dbName}
          onChange={(e) => setDbName(e.target.value)}
        />
      </div>
      <div>
        <label>Collection Name (Make sure it's not already exists !)</label>
        <input
          type="text"
          value={collectionName}
          onChange={(e) => setCollectionName(e.target.value)}
        />
      </div>
      <div>
        <button onClick={handleRunRoadLane}>
          Run Road Lane Process
        </button>
      </div>
      {showCheckMark && (
        <div className='check-mark'>Request {currentFolderId} Sent ✅</div>
      )}
      <div className='request-list'>
        <table>
          <thead>
            <tr>
              <th>Folder ID</th>
              <th>Start Time</th>
              <th>Status</th>
              <th>RoadLane Parameters</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <React.Fragment key={request.id}>
                <tr>
                  <td>{request.folderId}</td>
                  <td>{request.startTime}</td>
                  <td>
                    {request.loading ? (
                      <>Running...</>
                    ) : (
                      request.status
                    )}
                  </td>
                  <td>
                  <button className='btn btn-secondary' onClick={() => toggleParamsVisibility(request.id)}>
                    {request.showParams ? 'Hide' : 'Show'}
                  </button>
                  </td>
                  <td>
                    <button onClick={() => handleDeleteRequest(request.id)}>
                      <FaTrash />
                    </button>
                  </td>
                </tr>
                {request.showParams && (
                  <tr>
                    <td colSpan={5}>
                      <pre>{JSON.stringify(request.RoadLane_params, null, 2)}</pre>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <button className='clear-all-button' onClick={handleClearAll}>
          Remove All
        </button>
      </div>
    </div>
  );
};

export default RoadLaneTab;
